import type { RuleHandler } from "../types";

/*
  NOTE: this is different from minimumSelectionOdds
 - minimumSelectionOdds is used to check that every single outcome of a current bet has odds higher than X
 - minimumOdds is used to check that total odds of a bet is higher than X
 */

const checkMinimumOdds: RuleHandler = (context, requirement) => {
  const minimumOdds = requirement.userDrivenAttributes?.minimumOdds!;

  return context.selection.odds >= minimumOdds;
};

export { checkMinimumOdds };
